import { render, staticRenderFns } from "./FeedbackGlobal.vue?vue&type=template&id=60a6ef24&scoped=true&"
import script from "./FeedbackGlobal.vue?vue&type=script&lang=js&"
export * from "./FeedbackGlobal.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackGlobal.vue?vue&type=style&index=0&id=60a6ef24&scoped=true&lang=scss&"
import style1 from "./FeedbackGlobal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a6ef24",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VFileInput,VIcon,VNavigationDrawer,VOverlay,VTextarea})
